import type { ReactNode } from 'react';
import { cn } from '../ui/primitives';

/** The id an anchored section carries. One place decides, so a section and
 * anything scrolling to it can't disagree about it. */
export const sectionAnchorId = (id: string) => `quote-section-${id}`;

/** Scrolls a section under the sticky header rather than behind it. */
export function scrollToSection(id: string) {
	document
		.getElementById(sectionAnchorId(id))
		?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/** One anchored section of the page, wired to the tab strip above. */
export function QuoteSection({
	id,
	children,
	className,
}: {
	id: string;
	children: ReactNode;
	/** The tab layout hides the sections that aren't in the open tab through this. */
	className?: string;
}) {
	/* The sticky header would otherwise land on top of a section scrolled to. */
	return (
		<section id={sectionAnchorId(id)} className={cn('scroll-mt-[72px]', className)}>
			{children}
		</section>
	);
}
